import { useEffect, useRef } from 'react';
import { closeManualCopy, useManualCopy } from '../lib/share';
import { Button, Modal } from './ui';

/** Last resort when the browser blocks programmatic copying: the text, pre-selected. */
export function ManualCopyDialog() {
  const request = useManualCopy();
  const ref = useRef<HTMLTextAreaElement>(null);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    el.focus();
    el.setSelectionRange(0, el.value.length);
  }, [request]);

  if (!request) return null;
  return (
    <Modal
      title={`Copiar ${request.label}`}
      onClose={closeManualCopy}
      footer={
        <Button variant="primary" onClick={closeManualCopy}>
          Listo
        </Button>
      }
    >
      <p style={{ margin: 0 }} className="muted">
        Tu navegador no permitió copiarlo automáticamente. Mantén pulsado el texto (o usa Ctrl/⌘+C) y elige «Copiar».
      </p>
      <textarea
        ref={ref}
        className="textarea"
        readOnly
        rows={Math.min(8, request.text.split('\n').length + 1)}
        value={request.text}
        aria-label={request.label}
        style={{ fontSize: 16 }}
        onFocus={(e) => e.currentTarget.setSelectionRange(0, e.currentTarget.value.length)}
      />
    </Modal>
  );
}
